// extracted by mini-css-extract-plugin
export default {"img_common_style":"_1DiGHsaO8VObIwy94IVIqw==","img_loading_style":"CPYQimMK2+fZDwWgncoXTA=="};